import cn from 'classnames';

export const textControlClassName = cn(
	'block w-full min-h-[30px] min-w-0 border-0 bg-transparent p-0 font-sans text-2xl font-medium leading-[30px] tracking-[-0.025em] text-skin-default outline-none',
	/* глобальные стили: `input:focus { font-size: inherit }` — без `focus:*` размер прыгает */
	'focus:text-2xl focus:font-medium focus:leading-[30px] focus:outline-none focus:ring-0 focus:ring-offset-0',
	'placeholder:text-2xl placeholder:font-medium placeholder:leading-[30px] placeholder:text-skin-muted',
	'transition-none',
);
